import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'each' },
    { value: 2, label: 'tablets' },
    { value: 3, label: 'grams (g)' },
    { value: 4, label: 'milligrams (mg)' },
    { value: 5, label: 'millilitres (ml)' },
    { value: 6, label: 'micrograms (mcg)' },
    { value: 7, label: 'other' },
  ],
});
